import {SET_CACHE_ID, SET_FITLERS_URL, SOCKET_CONNECTED, UPDATE_FILTER_URL} from "../../actions/SocketActions";

const initialState = {
    socket: null,
    cacheId: '',
    code: '',
    urlFilters: {}
};

const SocketReducer = (state = initialState, action) => {
    switch (action.type) {
        case SOCKET_CONNECTED:
            return {
                ...state,
                socket: action.socket
            };
        case SET_CACHE_ID:
            return {
                ...state,
                cacheId: action.cacheId,
                code: action.code
            };
        case SET_FITLERS_URL:
            return {
                ...state, urlFilters: action.filters
            };
        case UPDATE_FILTER_URL:
            return {
                ...state, urlFilters: {...state.urlFilters, ...action.filter}
            };
        default:
            return state
    }
};

export default SocketReducer;



// WEBPACK FOOTER //
// ./src/reducers/socket/SocketReducer.js